// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_ITEM_DETAIL_REPORT_BUTTON = "Inzer\u00e1t nespl\u0148uje pravidla";
export const BZ2_ITEM_DETAIL_REPORT_MARK_OK = "Ozna\u010dit OK";
export const BZ2_ITEM_DETAIL_REPORT_MARK_OK_AND_NEXT = "Ozna\u010dit OK a j\u00edt d\u00e1l";
export const BZ2_PRODUCT_HAS_COMPLAINTS = "Inzer\u00e1t byl nahl\u00e1\u0161en\u00fd";
export const PRODUCT_REPORT_REPORT_PROBLEM = "Chci nahl\u00e1sit probl\u00e9m s obchodem";
